ata
<script setup lang="ts">
import Skeleton from 'primevue/skeleton';
</script>

<template>
  <div class="relative m-1 flex h-60 w-60 justify-center text-center">
    <Skeleton size="100%" border-radius="2rem" class="items-center bg-primary-200" />
    <i class="pi pi-image absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 transform text-primary-300" style="font-size: 4rem"></i>
  </div>
</template>
